import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";

export const canManageTeams = (): boolean => salesSettingsHelper.isHighLevelAccount();
